const PREFERENCES_DOMAIN = 'preferences'

const PREFERENCES_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}
const PREFERENCES_ACTION = {
  UPDATE_CURRENT: 'PREFERENCES_UPDATE_CURRENT',
  CREATE_EQUIPMENT_LIST: 'PREFERENCES_CREATE_EQUIPMENT_LIST',
  DELETE_EQUIPMENT_LIST: 'PREFERENCES_DELETE_EQUIPMENT_LIST',
  UPDATE_EQUIPMENT_LIST_NAME: 'PREFERENCES_UPDATE_EQUIPMENT_LIST_NAME',
  UPDATE_EQUIPMENT_LIST_DATA: 'PREFERENCES_UPDATE_EQUIPMENT_LIST_DATA',
  UPDATE_EQUIPMENT_LIST_SELECTED: 'PREFERENCES_UPDATE_EQUIPMENT_LIST_SELECTED',
  SAVE: 'PREFERENCES_SAVE',
  RESET_CURRENT: 'PREFERENCES_RESET_CURRENT',
  UPDATE_IS_PUSH_PLAN_START_WORKOUT_DISABLED: 'PREFERENCES_UPDATE_IS_PUSH_PLAN_START_WORKOUT_DISABLED',
  RESET_IS_PUSH_PLAN_START_WORKOUT_DISABLED: 'PREFERENCES_RESET_IS_PUSH_PLAN_START_WORKOUT_DISABLED',
  UPDATE_NOTIFICATION_WORKOUT_DISABLED: 'PREFERENCES_UPDATE_NOTIFICATION_WORKOUT_DISABLED',
  UPDATE_TRAINING_TIME: 'PREFERENCES_UPDATE_TRAINING_TIME'
}

const PREFERENCES_PATH = {
  ALL: `${PREFERENCES_DOMAIN}.${PREFERENCES_KEY.ALL}`,
  CURRENT: `${PREFERENCES_DOMAIN}.${PREFERENCES_KEY.CURRENT}`,
  DATA: `${PREFERENCES_DOMAIN}.${PREFERENCES_KEY.DATA}`
}

const PREFERENCES_STATE = {
  [PREFERENCES_KEY.ALL]: {
    data: [],
    status: null
  },
  [PREFERENCES_KEY.CURRENT]: null,
  [PREFERENCES_KEY.DATA]: {}
}

const PREFERENCES_ENDPOINT = {
  PREFERENCES: '/preferences'
}

export {
  PREFERENCES_DOMAIN,
  PREFERENCES_KEY,
  PREFERENCES_ACTION,
  PREFERENCES_PATH,
  PREFERENCES_STATE,
  PREFERENCES_ENDPOINT
}
